// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"adfeaa908c5d5303b0aa","303":"81b55252457f7c70acc4","495":"7004ad4a25d0bfacee8c"}[chunkId] + ".js";
};